export default __webpack_public_path__ + "static/company-bg-a54c0cae759967463b52b649ed63b8b3.png";